<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="vtableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="disabled ? 0 : 200"
      size="mini"
      :edit-rules="validRules"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span class="side-frame-text">阶梯价格信息</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="add()"
              v-if="!disabled"
              ><i class="el-icon-plus" />添加
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              v-if="!disabled"
              @click="$refs.table.removeCheckboxRow()"
              ><i class="el-icon-delete" />删除
            </b-button>
          </div>
        </slot>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    disabled: { type: Boolean },
    contractFeeCode: String,
    priceTypeString: String,
    basePrice: {
      type: [String, Number],
      require: false,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      vtableData: [],
      tableColumns: tableColumns(this.priceTypeString),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      validRules: {
        minMatch: [{ required: true, message: '请输入区间下限' }],
        maxMatch: [{ required: true, message: '请输入区间上限' }],
        price: [{ required: true, message: '请输入单位价' }],
      },
    }
  },
  watch: {
    // 避免父组件重新渲染子组件机制警告
    tableData: {
      handler(tableData) {
        if (tableData && tableData !== [] && tableData.length > 0) {
          this.vtableData = tableData
        }
      },
      immediate: true,
    },
    priceTypeString(newVal) {
      this.tableColumns = tableColumns(newVal)
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.contractFeeCode) return
      this.$api
        .contractCustomerFeeTieredListApi({
          contractFeeCode: this.contractFeeCode,
        })
        .then((res) => {
          this.vtableData = res.body.data
        })
    },
    async add(row) {
      const $table = this.$refs.table
      const { row: newRow } = await $table.insertAt(
        { basePrice: this.basePrice },
        row
      )
      await $table.setActiveCell(newRow, 'minMatch')
    },
    async getTableData() {
      const $table = this.$refs.table
      return await $table.getTableData().tableData
    },
    validEvent() {
      return this.$refs.table
        .fullValidate()
        .then(() => true)
        .catch(() => false)
    },
  },
}
</script>
